import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import * as vehiclesActions from '../actions/vehicles.actions';
import { map, catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { MwVehicleApiService } from 'app/services/vehicle-api.service';
import * as notifyActions from 'app/store/general/actions/notify.actions';

@Injectable()
export class VehicleEffects {
  loadVehicles$ = createEffect(() =>
    this.actions$.pipe(
      ofType(vehiclesActions.loadVehicles),
      switchMap(({ loadOptions }) =>
        this.vehiclesApiService.getVehicles(loadOptions).pipe(
          map((response) => vehiclesActions.loadVehiclesSuccess({ response })),
          catchError((error) =>
            of(vehiclesActions.loadVehiclesFailed({ error }))
          )
        )
      )
    )
  );

  createVehicle$ = createEffect(() =>
    this.actions$.pipe(
      ofType(vehiclesActions.createVehicle),
      switchMap(({ vehicle }) =>
        this.vehiclesApiService.createVehicle(vehicle).pipe(
          switchMap(() => [
            vehiclesActions.createVehicleSuccess(),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.add_vehicle_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(vehiclesActions.createVehicleFailed({ error }))
          )
        )
      )
    )
  );

  updateVehicle$ = createEffect(() =>
    this.actions$.pipe(
      ofType(vehiclesActions.updateVehicle),
      switchMap(({ vehicle }) =>
        this.vehiclesApiService.updateVehicle(vehicle).pipe(
          switchMap((response) => [
            vehiclesActions.updateVehicleSuccess(),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.edit_vehicle_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(vehiclesActions.updateVehicleFailed({ error }))
          )
        )
      )
    )
  );

  deleteVehicle$ = createEffect(() =>
    this.actions$.pipe(
      ofType(vehiclesActions.deleteVehicle),
      switchMap(({ vehicle }) =>
        this.vehiclesApiService.deleteVehicle(vehicle).pipe(
          switchMap(() => [
            vehiclesActions.deleteVehicleSuccess(),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.delete_vehicle_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(vehiclesActions.deleteVehicleFailed({ error }))
          )
        )
      )
    )
  );

  deleteVehiclesList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(vehiclesActions.deleteVehiclesList),
      switchMap(({ vehicles }) =>
        this.vehiclesApiService.deleteVehiclesList(vehicles).pipe(
          switchMap(() => [
            vehiclesActions.deleteVehiclesListSuccess(),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.delete_vehicles_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(vehiclesActions.deleteVehiclesListFailed({ error }))
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private vehiclesApiService: MwVehicleApiService
  ) {}
}
